import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { useIntl, defineMessages } from 'react-intl';
import { DropdownComponent, InputTextComponent, TextAreaComponent } from '../../components/prime-formik';

const i18nMessages = defineMessages({
  textType: {
    id: 'menu.item-bank-management.text-type',
    defaultMessage: 'Text Type',
  },
  level: {
    id: 'menu.item-bank-management.level',
    defaultMessage: 'Level',
  },
  sequence: {
    id: 'menu.item-bank-management.sequence',
    defaultMessage: 'Sequence',
  },
  textId: {
    id: 'menu.item-bank-management.textId',
    defaultMessage: 'Text Id',
  },
  text: {
    id: 'menu.item-bank-management.text',
    defaultMessage: 'Text',
  },
});

const AddReportText = ({
  section, availableReportTextTypes, availableTextLevels, availableSequences,
}) => {
  const { formatMessage } = useIntl();

  const { values } = useFormikContext();

  const reportTextTypeOptions = availableReportTextTypes.map(reportTextType => ({
    value: reportTextType,
    label: reportTextType,
  }));

  const filteredTextLevels = availableTextLevels.find(textLevel => textLevel.reportTextType === values.type);

  const textLevelOptions = filteredTextLevels
    ? filteredTextLevels.levels.map(level => ({
      value: level,
      label: level,
    }))
    : [];

  const filteredSequences = availableSequences.find(
    sequence => sequence.reportTextType === values.type && sequence.level === values.level,
  );

  const sequenceOptions = filteredSequences
    ? filteredSequences.sequences.map(sequence => ({
      value: sequence,
      label: sequence,
    }))
    : [];

  return (
    <>
      <Field type="hidden" value={section} name="sectionCode" />
      <div className="items-controls">
        <div>
          <div className="input-label">{formatMessage(i18nMessages.textType)}</div>
          <div>
            <Field id="type" name="type" component={DropdownComponent} options={reportTextTypeOptions} />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.level)}</div>
          <div>
            <Field id="level" name="level" component={DropdownComponent} options={textLevelOptions} />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.sequence)}</div>
          <div>
            <Field id="sequence" name="sequence" component={DropdownComponent} options={sequenceOptions} />
          </div>
        </div>
      </div>
      <div className="items-controls">
        <div>
          <div className="input-label">{formatMessage(i18nMessages.textId)}</div>
          <div>
            <Field id="code" name="code" component={InputTextComponent} />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.text)}</div>
          <div>
            <Field id="text" name="text" component={TextAreaComponent} />
          </div>
        </div>
      </div>
    </>
  );
};

AddReportText.propTypes = {
  section: PropTypes.string.isRequired,
  availableReportTextTypes: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableTextLevels: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableSequences: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default AddReportText;
